import { DescriptionOutlined } from '@mui/icons-material';
import { Button, DialogContent, Tab } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { SolaForceTabs } from '~/components/SolaForceTabs';
import { ViewSwitch } from '~/components/ViewSwitch';
import { EmplDetailHistory } from '~/legacy-components/ScheduleHistory/components/EmplDetailHistory';
import { EmploymentHistory } from '~/legacy-components/ScheduleHistory/components/EmplHistory';
import { EmplOtherHistory } from '~/legacy-components/ScheduleHistory/components/EmplOtherHistory';

import { useScheduleHistory } from './useScheduleHistory';
import { useSxStyles } from './useStyles';

export const ScheduleHistory = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const {
    emplHistory,
    emplDetailHistory,
    emplOtherHistory,
    isDialogOpen,
    openDialog,
    closeDialog,
  } = useScheduleHistory();

  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index: number) => {
    setToggleState(index);
  };

  return (
    <>
      <Button
        onClick={openDialog}
        startIcon={<DescriptionOutlined />}
        sx={sxStyles.btnLeftMargin}
        data-testid="btnScheduleHistory"
      >
        {t('laHistory')}
      </Button>
      <DraggableDialog
        open={isDialogOpen}
        onClose={() => closeDialog()}
        maxWidth={'xl'}
        PaperProps={{
          style: {
            minHeight: '90%',
            maxHeight: '90%',
          },
        }}
      >
        <SolaForceDialogTitle
          icon={<DescriptionOutlined />}
          onClose={closeDialog}
        >{`${t('laSchedule')} - ${t('laHistory')}`}</SolaForceDialogTitle>
        <SolaForceTabs
          value={toggleState}
          onChange={(_event, value) => toggleTab(value)}
        >
          <Tab value={1} label={t('laEmployment')} />
          <Tab value={2} label={t('laEmplDetail')} />
          <Tab value={3} label={t('laOtherHistory')} />
        </SolaForceTabs>
        <DialogContent sx={sxStyles.content}>
          <ViewSwitch condition={toggleState}>
            <ViewSwitch.Case when={1}>
              <EmploymentHistory data={emplHistory} />
            </ViewSwitch.Case>
            <ViewSwitch.Case when={2}>
              <EmplDetailHistory data={emplDetailHistory} />
            </ViewSwitch.Case>
            <ViewSwitch.Case when={3}>
              <EmplOtherHistory data={emplOtherHistory} />
            </ViewSwitch.Case>
          </ViewSwitch>
        </DialogContent>
      </DraggableDialog>
    </>
  );
};
